import {
    DashboardWidgetModel,
    DashboardWidgetType
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model';
import {
    DashboardWidgetObjectDefinition
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model-operator';

export class DashboardWidgetSepaInfoModel extends DashboardWidgetModel {
    public static $inject: string[] = DashboardWidgetModel.$inject.concat([
        'accountModel', 'depositModel'
    ]);

    public static dashboardWidgetDefinition: DashboardWidgetObjectDefinition = {
        demoData: {},
        manualAddable: false,
        userPermissions: {},
        systemNotification: 'switchToDirectDebit',
        widgetDescription: [],
        widgetObject: {
            attribute: {
                id: 'organDashboardWidgetSepaInfo',
                width: 2,
                height: 1,
                locked: true,
                noResize: true,
                noMove: true,
                autoPosition: true
            },
            componentTagName: 'organ-dashboard-widget-sepa-info',
            widgetModel: 'dashboardWidgetSepaInfoModel',
            version: '1.0'
        },
        widgetTitle: /* translationId */ 'TR_010221-dafbd9_TR',
        widgetType: DashboardWidgetType.system
    };

    public dashboardWidgetDefinition: DashboardWidgetObjectDefinition;

    constructor() {
        super();

        this.dashboardWidgetDefinition = DashboardWidgetSepaInfoModel.dashboardWidgetDefinition;
    }
}
